import CreditReportNavigation from './CreditReportNavigation';
export default CreditReportNavigation;
